import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import app from './modules/app';
import category from './modules/category';
import category_groups from './modules/category_groups';
import places from './modules/places';
import category_tree from './modules/category_tree';
import route from './modules/route';
import cities from './modules/cities';
import incidents from './modules/incidents';
import notifications from './modules/notifications';
import issues from './modules/issues';
import news from './modules/news';
import mayor from './modules/mayor';


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    app,
    category,
    category_groups,
    places,
    category_tree,
    route,
    cities,
    incidents,
    notifications,
    issues,
    news,
    mayor
  }
})
